import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

async function completeWorkpaper(id: string): Promise<void> {
    const { data } = await api.post(`/workpapers/${id}/complete`);
    return data;
}

export function useCompleteWorkpaper(id: string): UseMutationResult<void, AxiosError, unknown, unknown> {
    return useMutation(() => completeWorkpaper(id), {
        onSettled: () => {
            queryClient.invalidateQueries(['workpapers', id]);
            queryClient.invalidateQueries(['complete', 'status', id]);
        },
    });
}
